var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useRef } from "react";
import { Container, Label, Input, ErrorWrapper } from "./TextArea.styles";
import { useField } from "formik";
var idNum = 0;
export var TextArea = function (_a) {
    var _b = _a.label, label = _b === void 0 ? "" : _b, _c = _a.placeholder, placeholder = _c === void 0 ? "" : _c, _d = _a.value, value = _d === void 0 ? "" : _d, props = __rest(_a, ["label", "placeholder", "value"]);
    var _e = __read(useField(props), 2), field = _e[0], meta = _e[1]; // add meta for error handling
    var inputRef = useRef(null);
    var inputId = props.id ||
        "input-" + (label || (idNum++).toString()).replace(/\s+/g, "").trim();
    return (React.createElement(Container, null,
        label !== "" ? (React.createElement(Label, { htmlFor: inputId },
            label,
            meta.error && meta.touched ? (React.createElement(ErrorWrapper, { id: inputId + "Error" }, meta.error)) : null)) : null,
        React.createElement(Input, __assign({}, field, props, { ref: inputRef, id: inputId, placeholder: placeholder || label }))));
};
//# sourceMappingURL=TextArea.js.map